import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import { 
    OBJECT_SPECIALS, 
    JOB_SEND_REQUESTS, 
    ME_LIST_INPUT, 
    PersonTypeOptions,
    LOCAL_STORAGE_USER_LOGIN_INFO
} from "@app/constants/Common";
import * as CandidateService from '@app/services/CandidateService';
import {toast} from 'react-toastify';
import {checkExistsCommonFieldValues} from "@app/utils/CandidateUtils";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";

const FlowsCard = ({
    initialFlows,
    onChange,
    allInputInfo,
    onOpenHistory,
    candidateId,
    setIsEditFlows,
    mode = 'Edit', // Default to Edit mode for backward compatibility
    isEditFlows = false
}) => {
    const [isEdit, setIsEdit] = useState(isEditFlows);
    const [flows, setFlows] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(() => {
        setFlows(initialFlows || {});
    }, [initialFlows]);

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, []);

    const onChangeFlows = (event) => {
        flows[event.target.name] = event.target.value;
        setFlows({...flows});
        if (onChange) {
            onChange(flows);
        }
    };

    const onChangeValueFlows = (value, field) => {
        flows[field] = value;
        setFlows({...flows});
        if (onChange) {
            onChange(flows);
        }
    };

    const updateCandidateFlows = () => {
        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        flows.allFlowCategoriesInfo = allInputInfo.allFlowCategoriesInfo
        if (checkExistsCommonFieldValues(flows, userLoginInfo.id)) {
            return;
        }
        // setIsLoading(true)
        CandidateService.updateCandidateFlowsDetail({candidate_id: candidateId, flows: flows}).then((res) => {
            console.log(JSON.stringify(res))
            showSuccessMessageSaveData(res.sts_code)
            setIsEdit(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            // setIsLoading(false)
        });
    };

    const handleSave = () => {
        if (mode === 'Search') {
            // In Search mode, automatically call onChange without changing edit state
            if (onChange) onChange(flows);
        } else {
            // In Edit mode, call updateCandidateFlows and exit edit mode
            updateCandidateFlows();
        }
    };

    // Auto-save in Search mode when flows change
    useEffect(() => {
        if (mode === 'Search' && onChange) {
            onChange(flows);
        }
    }, [flows, mode, onChange]);

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Phân luồng</h3>
                {mode === 'Edit' && (
                    <div className='card-tools'>
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => setIsEdit(false)}>
                                Cancel
                            </button>
                        }
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={handleSave}>
                                Save
                            </button>
                        }
                        {!isEdit &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => setIsEdit(true)}>
                                Edit
                            </button>
                        }
                    </div>
                )}
            </div>
            <div className='card-body'>
                <div className='input-group'>
                    <label className={'w-100'}><b>UV lạ/quen</b></label>
                    <select className='form-control'
                            name={'candidate_know_state'}
                            disabled={!isEdit || flows.candidate_know_state === '4'}
                            value={flows.candidate_know_state}
                            onChange={event => onChangeFlows(event)}>
                        <option value=''>&nbsp;</option>
                        <option value='1'>N/A</option>
                        <option value='2'>UV lạ</option>
                        <option value='3'>UV quen chưa giới thiệu GP</option>
                        <option value='4' disabled={!userLoginInfo.is_superuser}>UV quen đã giới thiệu GP</option>
                    </select>
                    <AllUserInputField arrInfo={allInputInfo.allFlowCategoriesInfo}
                                       field='candidate_know_state'/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Đối tượng đặc biệt</b></label>
                    <div style={{width: '100%'}}>
                        <Select options={OBJECT_SPECIALS} isMulti
                                value={flows.object_special}
                                isDisabled={!isEdit}
                                name={'object_special'}
                                onChange={value => {
                                    onChangeValueFlows(value, 'object_special');
                                }}
                        />
                    </div>
                    <AllUserInputField arrInfo={allInputInfo.allFlowCategoriesInfo}
                                       field='object_special'/>
                </div>
                {mode === 'Edit' &&
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Yêu cầu gửi job</b></label>
                    <div style={{width: '100%'}}>
                        <Select options={JOB_SEND_REQUESTS} isMulti
                                isDisabled={!isEdit}
                                value={flows.job_send_request ? flows.job_send_request : ''}
                                name={'job_send_request'}
                                onChange={value => {
                                    onChangeValueFlows(value, 'job_send_request');
                                }}
                        />
                        <span>
                            <button type='button' className='btn btn-warning btn-flat btn-sm'
                                    onClick={onOpenHistory}>
                                Update History
                            </button>
                        </span>
                    </div>
                    <AllUserInputField arrInfo={allInputInfo.allFlowCategoriesInfo}
                                       field='job_send_request'/>
                </div>
                }
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Loại UV khỏi Search tiêu chuẩn</b></label>
                    <select className='form-control'
                            name={'standard_search_ignore'}
                            disabled={!isEdit}
                            value={flows.standard_search_ignore}
                            onChange={event => onChangeFlows(event)}>
                        <option value='1'>N/A</option>
                        <option value='2'>Loại UV</option>
                    </select>
                    <AllUserInputField arrInfo={allInputInfo.allFlowCategoriesInfo}
                                       field='standard_search_ignore'/>
                </div>
                {userLoginInfo.is_superuser &&
                    <div className='input-group mt-3'>
                        <label className={'w-100'}><b>Nhập list ME</b></label>
                        <select className='form-control'
                                name={'input_me_list'}
                                disabled={!isEdit}
                                value={flows.input_me_list}
                                onChange={event => onChangeFlows(event)}>
                            {ME_LIST_INPUT.map(item => (
                                <option value={item.value}
                                        key={`me-list-input-${item.value}`}>{item.label}</option>
                            ))}
                        </select>
                    </div>
                }
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Block UV</b></label>
                    <select className='form-control'
                            name={'block_state'}
                            disabled={!isEdit}
                            value={flows.block_state}
                            onChange={event => onChangeFlows(event)}>
                        <option value='1'>Unblock</option>
                        <option value='2'>Blocked</option>
                    </select>
                    <AllUserInputField arrInfo={allInputInfo.allFlowCategoriesInfo}
                                       field='block_state'/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Xếp loại UV</b></label>
                    <select className='form-control'
                            name={'candidate_type'}
                            disabled={!isEdit}
                            value={flows.candidate_type}
                            onChange={event => onChangeFlows(event)}>
                        {PersonTypeOptions.map(item => (
                            <option value={item.value}>{item.label}</option>
                        ))}
                    </select>
                    <AllUserInputField arrInfo={allInputInfo.allFlowCategoriesInfo}
                                       field='candidate_type'/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Note (Phân luồng)</b></label>
                    <input type='text' className='form-control'
                           value={flows.flow_note}
                           disabled={!isEdit}
                           name={'flow_note'}
                           onChange={event => onChangeFlows(event)}/>
                    <AllUserInputField arrInfo={allInputInfo.allFlowCategoriesInfo}
                                       field='flow_note'/>
                </div>
            </div>
        </div>
    );
};

export default FlowsCard;


